import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  theme => ({
    backContainer: {
      display: "flex",
      gap: `${theme.spacing(2)}px`,
      marginTop: "10px"
    },
    container: {
      display: "flex",
      gap: `${theme.spacing(2)}px`
    },
    title: {
      fontSize: "1.5rem",
      fontWeight: 600
    }
  }),
  { name: "CouponSetCodePage" }
);

export default useStyles;
